// findValues extracts values from an array and only returns the values that are not null or undefined.
export function findValues(input, mapper) { return input.map(mapper).filter(v => v !== null && v !== undefined); }
export function firstValue(input, mapper) { const list = findValues(input, mapper); return list.length ? list[0] : null; }
